import logger from './logger';

interface CircuitBreakerState {
  failures: number;
  lastFailure: number | null;
  isOpen: boolean;
}

// Estado global del circuit breaker
const state: CircuitBreakerState = {
  failures: 0,
  lastFailure: null,
  isOpen: false,
};

// Configuración
const FAILURE_THRESHOLD = 5;      // 5 fallos consecutivos abren el circuito
const RESET_TIMEOUT_MS = 30000;   // 30 segundos para intentar recuperar
const RETRYABLE_STATUSES = [500, 502, 503, 504];

// Callbacks para notificar cambios de estado
let onCircuitOpen: (() => void) | null = null;
let onCircuitClose: (() => void) | null = null;

export function setCircuitBreakerCallbacks(
  onOpen: () => void,
  onClose: () => void
) {
  onCircuitOpen = onOpen;
  onCircuitClose = onClose;
}

export function recordSuccess() {
  if (state.failures > 0 || state.isOpen) {
    logger.log('[CircuitBreaker] Success - resetting state');
    state.failures = 0;
    state.lastFailure = null;
    
    if (state.isOpen) {
      state.isOpen = false;
      onCircuitClose?.();
    }
  }
}

export function recordFailure(status?: number) {
  // Solo contar fallos de servidor (5xx), no errores de cliente (4xx)
  if (status && !RETRYABLE_STATUSES.includes(status)) {
    return;
  }
  
  state.failures++;
  state.lastFailure = Date.now();
  
  logger.warn(`[CircuitBreaker] Failure recorded (${state.failures}/${FAILURE_THRESHOLD})`);
  
  if (state.failures >= FAILURE_THRESHOLD && !state.isOpen) {
    state.isOpen = true;
    logger.error('[CircuitBreaker] Circuit OPEN - API appears to be down');
    onCircuitOpen?.();
    
    // Auto-cerrar después del timeout para intentar recuperar
    setTimeout(() => {
      if (state.isOpen) {
        logger.log('[CircuitBreaker] Attempting recovery...');
        state.isOpen = false;
        state.failures = Math.floor(FAILURE_THRESHOLD / 2); // Medio abierto
        onCircuitClose?.();
      }
    }, RESET_TIMEOUT_MS);
  }
}

export function isCircuitOpen(): boolean {
  return state.isOpen;
}

export function getCircuitState(): CircuitBreakerState {
  return { ...state };
}
